import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

import 'gumshoejs/src/js/gumshoe/_closest.polyfill'
import 'gumshoejs/src/js/gumshoe/_customEvent.polyfill'
import Gumshoe from 'gumshoejs/src/js/gumshoe/gumshoe'
import { tns } from '../node_modules/tiny-slider/src/tiny-slider'

if (document.querySelector('.page.page-homepage')) {
  let currentSlide = document.querySelector('#current-slide')

  const slider = tns({
    container: document.querySelector('#slider-comments'),
    nav: false,
    controls: false,
    center: false,
    loop: false,
    items: 1,
    fixedWidth: false,
    gutter: 0,
    responsive: {
      768: {
        items: 3,
        gutter: 16
      }
    }
  })

  document.querySelector('#slide-count').innerHTML = slider.getInfo().slideCountNew
  currentSlide.innerHTML = slider.getInfo().displayIndex

  document.querySelectorAll('#slider-comments-prev-button').forEach(button => button.addEventListener('click', () => {
    slider.pause()
    slider.play()
    slider.goTo('prev')

    currentSlide.innerHTML = slider.getInfo().displayIndex
  }))

  document.querySelectorAll('#slider-comments-next-button').forEach(button => button.addEventListener('click', () => {
    slider.pause()
    slider.play()
    slider.goTo('next')

    currentSlide.innerHTML = slider.getInfo().displayIndex
  }))
}

if (document.querySelector('.page.page-what-we-offer')) {
  const spy = new Gumshoe('.flex-offers-navigation a', {
    offset: () => {
      return document.getElementById('navigation').offsetHeight + document.getElementById('offers-navigation').offsetHeight
    }
  })

  document.querySelectorAll('.flex-offers-navigation a').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      window.scroll({
        top: document.querySelector(`${e.target.hash}`).offsetTop - (document.getElementById('navigation').offsetHeight + document.getElementById('offers-navigation').offsetHeight),
        left: 0,
        behavior: 'smooth'
      })
    })
  })

  if (window.location.hash) {
    window.scroll({
      top: document.querySelector(`${window.location.hash}`).offsetTop - (document.getElementById('navigation').offsetHeight + document.getElementById('offers-navigation').offsetHeight),
      left: 0,
      behavior: 'smooth'
    })
  }
}
